<template>
  <div style="background:#fff; padding:20px;">
    <div style="margin-bottom: 20px">
      <a-button type="primary" icon="plus" @click="handleAdd">新增角色</a-button>
    </div>

    <a-table :columns="columns" :data-source="data" rowKey="id" :loading="loading">
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">权限分配</a>
        <a-divider type="vertical" />
        <a-popconfirm title="确定删除该角色吗？关联的用户将失去该角色。" @confirm="handleDelete(record.id)">
          <a style="color: red">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal v-model="visible" title="角色编辑" @ok="handleOk">
      <a-form-model :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="角色名称">
          <a-input v-model="form.roleName" />
        </a-form-model-item>
        <a-form-model-item label="角色标识">
          <a-input v-model="form.roleKey" placeholder="如: admin" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-model="permVisible" title="分配菜单权限" @ok="handlePermOk" @cancel="handlePermCancel">
      <a-tree checkable :tree-data="menuTree" :replace-fields="{children:'children', title:'title', key:'id'}"
        v-model="checkedKeys" defaultExpandAll />
    </a-modal>
  </div>
</template>

<script>
  import {
    getRoleList,
    deleteRole
  } from '@/api'
  import request from '@/utils/request'

  export default {
    data() {
      return {
        data: [],
        loading: false,
        visible: false,
        permVisible: false,
        form: {},
        columns: [{
          title: 'ID',
          dataIndex: 'id'
        }, {
          title: '角色名称',
          dataIndex: 'roleName'
        }, {
          title: '标识',
          dataIndex: 'roleKey'
        }, {
          title: '操作',
          key: 'action',
          scopedSlots: {
            customRender: 'action'
          }
        }],
        // 权限相关
        currentRoleId: null,
        menuTree: [],
        checkedKeys: []
      }
    },
    created() {
      this.loadData()
    },
    methods: {
      loadData() {
        this.loading = true
        getRoleList().then(res => {
          this.data = res.data
          this.loading = false
        })
      },
      handleAdd() {
        this.form = {}
        this.visible = true
      },
      handleDelete(id) {
        deleteRole({ id: id }).then(() => {
          this.$message.success('删除成功');
          this.loadData();
        });
      },
      handleOk() {
        if (!this.form.roleName || !this.form.roleName.trim()) {
          this.$message.warning('请填写角色名称')
          return
        }
        request.post('/role/add', this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.loadData()
        })
      },
      // 点击分配权限
      handleEdit(record) {
        this.currentRoleId = record.id
        this.permVisible = true
        this.checkedKeys = []
        // 1. 获取所有菜单树
        request.get('/menu/list').then(res => {
          this.menuTree = res.data
        })
        // 2. 回显该角色已分配的菜单
        request.get('/role/menus', { params: { roleId: record.id } }).then(res => {
          this.checkedKeys = res.data || []
        })
      },
      handlePermCancel() {
        this.permVisible = false
        this.checkedKeys = []
        this.currentRoleId = null
      },
      handlePermOk() {
        // 发送勾选的菜单ID
        request.post('/role/assign-menus', {
          roleId: this.currentRoleId,
          menuIds: this.checkedKeys.checked || this.checkedKeys // 兼容 Ant Design Vue 的不同版本行为
        }).then(() => {
          this.$message.success('权限分配成功')
          this.permVisible = false
          this.checkedKeys = []
        })
      }
    }
  }
</script>
